import React from 'react';

class Clients extends React.Component{
    render() {
        return(
            <div className="partners">
                <div className="partners__bg">
                    <div className="container">
                        <div className="partners__block"><p className="partners__title">Наши клиенты</p><p
                            className="partners__subtitle">Мы любим сотрудничать и помогать тем, кто в нас
                            заинтересован.</p>
                            <div className="partners__logo-list"><img className="partners__logo"
                                                                      src="images/client-1-100_burned.png" width="85"
                                                                      height="98" alt="" role="presentation"/><img
                                className="partners__logo" src="images/client-2_burned.png" width="153" height="94" alt=""
                                role="presentation"/><img className="partners__logo" src="images/client-3_burned.png"
                                                          width="223" height="93" alt="" role="presentation"/><img
                                className="partners__logo" src="images/client-5_burned.png" width="329" height="85" alt=""
                                role="presentation"/></div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Clients;


// WEBPACK FOOTER //
// ./src/Components/MainPage/Clients.js